module.exports = __webpack_public_path__ + "img/hb3.907e4e10.jpg";